
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/glitch",
      function () {
        return require("private-next-pages/glitch/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/glitch"])
      });
    }
  